import { render, staticRenderFns } from "./TagItem.vue?vue&type=template&id=66d2f498&"
import script from "./TagItem.vue?vue&type=script&lang=js&"
export * from "./TagItem.vue?vue&type=script&lang=js&"
import style0 from "./TagItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports